import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from "react-redux";
import ApplicationPolicy from "../components/applicationPolicy";
import {
	changeActiveTab, changeApplicationPolicySettings, closePremiumSettingsModal as closePremiumSettingsModalAction,
	checkUserOverviewTabCheckBox, requestApplicationAttachment, requestApplicationNotification,
	requestApplicationPremiumSettings,
	requestDeleteDocument, requestRenameAttachment, openRenameAttachmentModal, closeRenameAttachmentModal,
	transferApplicationBetweenSolicitorUsers, requestPatchTransferApplicationBetweenSolicitors, requestGetTransferOutcome, requestDeleteApplicationPremiumSettings,
	openFilePreview, closeFilePreview, selectApplicationStatus, applyPig
} from "../actions/applicationPolicy";
import FilePreviewModal from '../components/General/FilePreviewModal';
import { requestGetSolicitors } from "../actions/agentsList";
import { requestLawsysFirmsWithAgents } from "../actions/lawsysFirms";
import {
	changeNewAppField, fetchApplicationByIdAfterApplicationAnswerUpdate, requestGetSelectedApplication,
	requestPatchApplication
} from "../actions/newApplication";
import {
	changeOverViewTabReadMoreState, overviewTabPageShift
} from "../actions/overviewTab";
import { requestPatchNotification } from "../actions/notifications";
import { changeUpdatePolicyField, getCostsSummary } from "../actions/updateTab";
import { requestPremiumSettingsDamages } from "../actions/premiumSettings";
import { replace } from 'connected-react-router';
import _ from 'lodash';
import { getUserGroups } from "../actions/usersList";
import { _getFileFromBase64, isAragUser, isSolicitorUser } from "../helpers/functions";
import { POLICY_LINK_TO_POLICY_TAB_LOOKUP_TABLE, PREMIUM_SETTINGS_CHECKBOX_OPTIONS } from "../helpers/variables";
import { resetApplicationPremium, changePremiumSettingsWizardStore } from "../actions/premiumSettingsWizard";
import { checkLawsysFirmBankAccountValidity } from "../actions/lawsysFirms";
import { resetApplicationStagedPremium } from '../reducers/stagedPremiumsWizard';
import { resetStagedPremiumState } from '../reducers/stagedPremiums';
import { getApplicableInternalAlerts } from '../reducers/internalAlerts';
import { requestGetApplicationStatuses } from '../actions/applicationStatuses';
import {
	REFERRED_OPTIONS, POLICY_SCHEDULE, POLICY_STATUS_MN_REFERRED, MEDICAL_EXPERT, TECHNICAL_UNDERWRITER, UNDERWRITER,
	REFERRED_KEY_MEDICAL_EXPERT_MN, REFERRED_KEY_TECHNICAL_UNDERWRITER_MN, REFERRED_KEY_UNDERWRITER_MN,
	POLICY_STATUS_MN_LIVE, INITIAL_OPTIONS, POLICY_STATUS_MN_WON, POLICY_STATUS_MN_WON_PART36, POLICY_STATUS_MN_WON_RULE49,
	BAD_MSG,
} from '../helpers/constants';
import { FEATURE_FLAGS } from '../constants/configurationKeys';
import useFeatureFlag from '../hooks/useFeatureFlag';


const ApplicationPolicyHOC = (props) => {

	const { match } = props;

	const dispatch = useDispatch();
	const applicationPolicy = useSelector(state => state.applicationPolicy);
	const applicationAcceptedStatusesTransitions = useSelector(state => state.applicationAcceptedStatusesTransitions);
	const applicationsAndPolicies = useSelector(state => state.applicationsAndPolicies);
	const updateTab = useSelector(state => state.updateTab);
	const user = useSelector(state => state.user);
	const newApplication = useSelector(state => state.newApplication);
	const badResponseAppPsMessage = useSelector(state => state.premiumSettingsWizard.badResponseMsg);
	const agentsList = useSelector(state => state.agentsList);
	const lawsysFirms = useSelector(state => state.lawsysFirms);
	const internalAlerts = useSelector(state => state.internalAlerts.applicableInternalAlerts);
	const applicationStatuses = useSelector(state => state.applicationStatuses);
	const userGroups = useSelector(state => state.usersList.userGroups);
	const router = useSelector(state => state.router);
	const erpOrganisationValidationEnabled = useFeatureFlag(FEATURE_FLAGS.ERP_ORGANISATION_VALIDATION_ENABLED);
	const advanceDisbursementsEnabled = useFeatureFlag(FEATURE_FLAGS.ADVANCE_DISBURSEMENTS_ENABLED);

	const filePreview = applicationPolicy.filePreview;
	const isArag = isAragUser(user.loggedInUser.roles);
	const isSolicitor = isSolicitorUser(user.loggedInUser.roles);

	const [isEditingApplicationPremium, setIsEditingApplicationPremium] = useState(false);
	const [costsSummaryModalOpen, setCostsSummaryModalOpen] = useState(false);
	const [internalAlertModal, setInternalAlertModal] = useState(false);
	const [editingStaged, setEditingStaged] = useState(false);

	const prevFetchingDocumentRef = useRef(applicationPolicy.fetchingDocument);
	const prevFetchingSelectedAppAragRef = useRef(newApplication.fetchingSelectedApp);
	const prevFetchingSelectedAppSolicitorRef = useRef(newApplication.fetchingSelectedApp);
	const prevUpdatingQuestionAnswerRef = useRef(newApplication.updatingQuestionAnswer);
	const prevTransferringApplicationRef = useRef(applicationPolicy.transferringApplication);
	const prevApplyingPigRef = useRef(applicationPolicy.applyingPig);

	// componentWillMount
	useEffect(() => {
		const pathname = router.location.pathname;

		if (isNaN(_.last(pathname.split('/')))) {
			dispatch(replace(match.url));
			dispatch(changeActiveTab(POLICY_LINK_TO_POLICY_TAB_LOOKUP_TABLE[_.last(pathname.split('/'))]));
		}

		if (pathname.includes('wording')) {
			dispatch(replace(match.url));
			dispatch(changeApplicationPolicySettings('wordingId', _.last(pathname.split('/'))));
			dispatch(changeActiveTab(POLICY_LINK_TO_POLICY_TAB_LOOKUP_TABLE['wording']));
		}

		if (pathname.includes('ipid')) {
			dispatch(replace(match.url));
			dispatch(changeActiveTab(POLICY_LINK_TO_POLICY_TAB_LOOKUP_TABLE['ipid']));
		}

		const splitedRoute = _.split(pathname, '/', 4);
		const splitId = splitedRoute[3];

		dispatch(requestPremiumSettingsDamages());
		if (pathname.includes('/application-and-policies/application-policy')) {
			dispatch(requestGetSelectedApplication(splitId));
			dispatch(requestApplicationNotification({ applicationId: splitId }));
		} else {
			if ((Object.keys(applicationsAndPolicies.selectedApplication).length !== 0 &&
				applicationsAndPolicies.selectedApplication.constructor === Object) &&
				(!newApplication.fetchingSelectedApp)) {
				dispatch(requestGetSelectedApplication(applicationsAndPolicies.selectedApplication.id));
			}
		}

		if (isArag) {
			dispatch(getUserGroups());
			dispatch(requestLawsysFirmsWithAgents(user.loggedInUser.token));
		}

		if (isArag) {
			if ((Object.keys(applicationsAndPolicies.selectedApplication).length !== 0 &&
				applicationsAndPolicies.selectedApplication.constructor === Object) &&
				(!newApplication.fetchingSelectedApp)) {
				dispatch(getApplicableInternalAlerts(applicationsAndPolicies.selectedApplication.id));
			}
		}
		dispatch(requestGetApplicationStatuses());
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		const prevFetching = prevFetchingDocumentRef.current;
		prevFetchingDocumentRef.current = applicationPolicy.fetchingDocument;
		if (prevFetching && !applicationPolicy.fetchingDocument && applicationPolicy.failedToGetDocumentMsg === '') {
			if (!applicationPolicy.filePreview.isOpen) {
				_getFileFromBase64(applicationPolicy.documentToDownload);
			}
		}
	}, [
		applicationPolicy.fetchingDocument,
		applicationPolicy.failedToGetDocumentMsg,
		applicationPolicy.filePreview.isOpen,
		applicationPolicy.documentToDownload,
	]);

	useEffect(() => {
		const prevFetching = prevFetchingSelectedAppAragRef.current;
		prevFetchingSelectedAppAragRef.current = newApplication.fetchingSelectedApp;
		if (prevFetching && !newApplication.fetchingSelectedApp &&
			isArag && applicationsAndPolicies.selectedApplication.id && erpOrganisationValidationEnabled
		) {
			dispatch(checkLawsysFirmBankAccountValidity({
				lawsysId: applicationsAndPolicies.selectedApplication.lawsysId
			}));
		}
	}, [
		newApplication.fetchingSelectedApp,
		isArag,
		applicationsAndPolicies.selectedApplication.id,
		applicationsAndPolicies.selectedApplication.lawsysId,
		erpOrganisationValidationEnabled,
		dispatch,
	]);

	useEffect(() => {
		const prevFetching = prevFetchingSelectedAppSolicitorRef.current;
		prevFetchingSelectedAppSolicitorRef.current = newApplication.fetchingSelectedApp;
		if (prevFetching && !newApplication.fetchingSelectedApp &&
			isSolicitor &&
			newApplication.application &&
			(newApplication.application.policyStatusMachineName === POLICY_STATUS_MN_WON ||
			newApplication.application.policyStatusMachineName === POLICY_STATUS_MN_WON_PART36 ||
			newApplication.application.policyStatusMachineName === POLICY_STATUS_MN_WON_RULE49) &&
			updateTab.costsSummary === '' &&
			updateTab.costsSummaryError === ''
		) {
			dispatch(getCostsSummary(newApplication.application.id));
			setCostsSummaryModalOpen(true);
		}
	}, [
		newApplication.fetchingSelectedApp,
		isSolicitor,
		newApplication.application,
		updateTab.costsSummary,
		updateTab.costsSummaryError,
		dispatch,
	]);

	useEffect(() => {
		const prevUpdating = prevUpdatingQuestionAnswerRef.current;
		prevUpdatingQuestionAnswerRef.current = newApplication.updatingQuestionAnswer;
		if (prevUpdating && !newApplication.updatingQuestionAnswer && !newApplication.updatingQuestionAnswerFail) {
			dispatch(fetchApplicationByIdAfterApplicationAnswerUpdate({
				applicationId: applicationsAndPolicies.selectedApplication.id
			}));
		}
	}, [
		newApplication.updatingQuestionAnswer,
		newApplication.updatingQuestionAnswerFail,
		applicationsAndPolicies.selectedApplication.id,
		dispatch,
	]);

	useEffect(() => {
		const prevTransferring = prevTransferringApplicationRef.current;
		prevTransferringApplicationRef.current = applicationPolicy.transferringApplication;
		if (prevTransferring && !applicationPolicy.transferringApplication && applicationPolicy.badResponseTransferApplication === "") {
			dispatch(requestGetSelectedApplication(applicationsAndPolicies.selectedApplication.id));
		}
	}, [
		applicationPolicy.transferringApplication,
		applicationPolicy.badResponseTransferApplication,
		applicationsAndPolicies.selectedApplication.id,
		dispatch,
	]);

	useEffect(() => {
		const prevApplying = prevApplyingPigRef.current;
		prevApplyingPigRef.current = applicationPolicy.applyingPig;
		if (prevApplying && !applicationPolicy.applyingPig && applicationPolicy.badResponseApplyPig === "") {
			dispatch(requestGetSelectedApplication(newApplication.selectedApplication.id));
		}
	}, [
		applicationPolicy.applyingPig,
		applicationPolicy.badResponseApplyPig,
		newApplication.selectedApplication.id,
		dispatch,
	]);

	useEffect(() => {
		if (!applicationPolicy.documentData) return;
		_getFileFromBase64({
			encodedFile: applicationPolicy.documentData,
			name: 'ARAG_Policy_' + POLICY_SCHEDULE + '_' + newApplication.selectedApplication.aragReference + '_' + _.replace(newApplication.selectedApplication.clientName, / /g, '_') + '.pdf',
		});
		// Clear immediately so the next request for the same document re-triggers this effect.
		// aragReference and clientName are intentionally omitted from deps — they are filename
		// components read at fire time, not triggers for the download.
		dispatch(changeApplicationPolicySettings('documentData', ''));
	}, [applicationPolicy.documentData]); // eslint-disable-line react-hooks/exhaustive-deps

	// US 101077: BuD acknowledges the firm change on a queue, which lands after the transfer response.
	// There is no push channel, so poll briefly for the outcome and let the reducer raise the banner.
	// The deadline is set by RECEIVE_PATCH_TRANSFER...; the reducer zeroes it once a warning arrives.
	useEffect(() => {
		const deadline = applicationPolicy.pollTransferOutcomeUntil;
		const id = applicationsAndPolicies.selectedApplication.id;
		if (!deadline || !id) return;

		const timer = setInterval(() => {
			if (Date.now() > deadline) {
				clearInterval(timer);
				// Reset rather than leave a stale past timestamp, which stays truthy and would start a
				// throwaway timer on every later mount of the page.
				dispatch(transferApplicationBetweenSolicitorUsers('pollTransferOutcomeUntil', 0));
				return;
			}
			dispatch(requestGetTransferOutcome(id));
		}, 2000);

		return () => clearInterval(timer);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [applicationPolicy.pollTransferOutcomeUntil]);

	useEffect(() => {
		if (!applicationPolicy.premiumSettingsChanged) return;
		dispatch(changeApplicationPolicySettings('premiumSettingsChanged', false));
		// selectedApplication.id and dispatch are intentionally omitted — they are read at fire
		// time, not triggers. The flag is the only signal that a refetch is needed.
		dispatch(requestGetSelectedApplication(applicationsAndPolicies.selectedApplication.id));
	}, [applicationPolicy.premiumSettingsChanged]); // eslint-disable-line react-hooks/exhaustive-deps

	// RECEIVE_PATCH_APPLICATION refreshes newApplication.selectedApplication but not the
	// applicationsAndPolicies copy the premium settings area reads, so WI 97790's status-driven lock stays
	// stale after a status change. Watching for divergence rather than a patch flag also covers go-live,
	// whose refetch above races the PATCH that sets Live.
	useEffect(() => {
		const id = applicationsAndPolicies.selectedApplication.id;
		if (!id || newApplication.selectedApplication.id !== id) return;
		if (newApplication.fetchingSelectedApp) return;
		const patchedStatus = newApplication.selectedApplication.policyStatusMachineName;
		const staleStatus = applicationsAndPolicies.selectedApplication.policyStatusMachineName;
		if (!patchedStatus || !staleStatus || patchedStatus === staleStatus) return;
		dispatch(requestGetSelectedApplication(id));
	}, [
		newApplication.selectedApplication.id,
		newApplication.selectedApplication.policyStatusMachineName,
		newApplication.fetchingSelectedApp,
		applicationsAndPolicies.selectedApplication.id,
		applicationsAndPolicies.selectedApplication.policyStatusMachineName,
		dispatch,
	]);

	const editApplicationPremium = () => {
		setIsEditingApplicationPremium(true);
	};

	const cancelEditOfApplicationPremium = () => {
		dispatch(resetApplicationStagedPremium());
		dispatch(resetApplicationPremium());
		dispatch(resetStagedPremiumState());
		setIsEditingApplicationPremium(false);
		setEditingStaged(false);
	};

	const closePremiumSettingsModal = () => {
		if (isEditingApplicationPremium) {
			// Only reset wizard data when cancelling an active edit — avoids clearing the shared
			// Redux slices that the always-rendered ApplicationPremiumSettingsHOC in newApplication.js reads,
			// which would cause it to show a spinner requiring a full page refresh.
			cancelEditOfApplicationPremium();
		}
		// Conflict-flow delete: record was created in this attempt; removing it lets the next
		// attempt re-run the conflict check and re-show the type selector.
		// multipleAppPremiumSettingsFound is false after a successful go-live, so
		// retry cancels never reach this branch.
		if (applicationPolicy.multipleAppPremiumSettingsFound) {
			const premiumSettingId = applicationPolicy.premiumSettings?.id;
			if (premiumSettingId) {
				dispatch(requestDeleteApplicationPremiumSettings({
					applicationId: applicationsAndPolicies.selectedApplication.id,
					appPremiumSettingId: premiumSettingId
				}));
			}
		}
		setEditingStaged(false);
		dispatch(closePremiumSettingsModalAction());
	};

	const handleSolicitorFirmSelect = (lawsysId) => {
		const parameters = {
			orderAsc: true,
			orderBySolicitorName: false,
			orderByLawsysId: false,
			orderByLawsysName: false,
			orderByUserName: true,
			limit: null,
			offset: 0,
			lawsysId: lawsysId,
			search: null,
			// WI 102256 AC12: linked-firm users are selectable for every policy, Drafts included (WI 101242 had excluded them)
			includeLinkedFirms: true,
		};
		dispatch(requestGetSolicitors(parameters));
		dispatch(transferApplicationBetweenSolicitorUsers('solicitorFirmIdSelected', lawsysId));
		// a user picked for the previous firm must not ride along into the new firm's list
		dispatch(transferApplicationBetweenSolicitorUsers('solicitorFirmUserIdSelected', ''));
	};

	const handleSolicitorSelect = (userId) => {
		dispatch(transferApplicationBetweenSolicitorUsers('solicitorFirmUserIdSelected', userId));
	};

	const applicationStatus = (statusMachineName) => {
		return applicationStatuses.statuses.find(status => status.machineName === statusMachineName)?.name || statusMachineName;
	};

	const userDropDownStatusOptions = (status, referredToName, appAcceptedStatusesTransitions, policyStatusMachineName) => {
		let referredOptions = [];

		const transitions = appAcceptedStatusesTransitions?.transitions
			.filter(transition =>
				transition.item1 === policyStatusMachineName
				&& transition.item2 !== POLICY_STATUS_MN_REFERRED
			)
			.map(transition => ({ key: transition.item2, label: applicationStatus(transition.item2) || transition.item2 }));

		if (appAcceptedStatusesTransitions?.transitions
			.filter(transition =>
				transition.item1 === policyStatusMachineName
				&& transition.item2 === POLICY_STATUS_MN_REFERRED
			).length > 0) {
			referredOptions = REFERRED_OPTIONS;
			if (policyStatusMachineName === POLICY_STATUS_MN_REFERRED) {
				if (referredToName === MEDICAL_EXPERT) {
					referredOptions = referredOptions.filter(option => option.key !== REFERRED_KEY_MEDICAL_EXPERT_MN);
				} else if (referredToName === UNDERWRITER) {
					referredOptions = referredOptions.filter(option => option.key !== REFERRED_KEY_UNDERWRITER_MN);
				} else if (referredToName === TECHNICAL_UNDERWRITER) {
					referredOptions = referredOptions.filter(option => option.key !== REFERRED_KEY_TECHNICAL_UNDERWRITER_MN);
				}
			}
		}

		return [...INITIAL_OPTIONS, ...referredOptions, ...transitions];
	};

	const _updatePolicyStatus = () => {
		if (applicationPolicy.selectedStatusMachineName === POLICY_STATUS_MN_LIVE &&
			!applicationPolicy.openPremiumSettingsModal) {
			dispatch(requestApplicationPremiumSettings({
				id: newApplication.selectedApplication.id,
				openModal: true,
				premiumType: applicationPolicy.premiumSettingsType
			}));
			return false;
		}
		const selectedStatusMachineName = applicationPolicy.selectedStatusMachineName;
		const isReferredOption = selectedStatusMachineName === REFERRED_KEY_MEDICAL_EXPERT_MN ||
			selectedStatusMachineName === REFERRED_KEY_TECHNICAL_UNDERWRITER_MN ||
			selectedStatusMachineName === REFERRED_KEY_UNDERWRITER_MN;
		const policyStatusMachineName = isReferredOption ? POLICY_STATUS_MN_REFERRED : selectedStatusMachineName;
		let selectedReferredOption;
		let filteredStatus = '';

		if (selectedStatusMachineName === REFERRED_KEY_MEDICAL_EXPERT_MN) {
			filteredStatus = MEDICAL_EXPERT;
		} else if (selectedStatusMachineName === REFERRED_KEY_TECHNICAL_UNDERWRITER_MN) {
			filteredStatus = TECHNICAL_UNDERWRITER;
		} else if (selectedStatusMachineName === REFERRED_KEY_UNDERWRITER_MN) {
			filteredStatus = UNDERWRITER;
		}
		const gr = _.find(userGroups, group => group.roleName === filteredStatus);
		if (gr) {
			selectedReferredOption = gr.id;
		}
		dispatch(requestPatchApplication({
			id: newApplication.selectedApplication.id,
			policyStatus: policyStatusMachineName,
			roleGroupId: selectedReferredOption,
			sendEmail: applicationPolicy.sendEmailNotification,
			abandonedReason: newApplication.abandonedReason ? newApplication.abandonedReason : null,
			rejectedReason: newApplication.rejectedReason ? newApplication.rejectedReason : null,
			referralReasons: newApplication.referredReason ? [newApplication.referredReason] : null
		}));
	};

	const _transferApplication = (confirmed) => {
		dispatch(requestPatchTransferApplicationBetweenSolicitors({
			applicationId: newApplication.selectedApplication.id,
			sendBody: {
				OldSolicitorLawsysFirmId: newApplication.selectedApplication.lawsysId,
				OldApplicationUserId: newApplication.selectedApplication.applicationUserId,
				NewSolicitorLawsysFirmId: applicationPolicy.solicitorFirmIdSelected,
				NewApplicationUserId: applicationPolicy.solicitorFirmUserIdSelected,
				isConfirmed: confirmed
			}
		}));
	};

	const _openAdvancedDisbursementsApplicationModal = () => {
		dispatch(changeApplicationPolicySettings('advancedDisbursementsApplicationModalOpen', true));
	};

	const _closeAdvancedDisbursementsApplicationModal = () => {
		dispatch(changeApplicationPolicySettings('advancedDisbursementsApplicationModalOpen', false));
	};

	const handleOpenApplyPigModal = () => {
		dispatch(changeApplicationPolicySettings('openApplyPigModal', true));
	};

	const handleCloseApplyPigModal = () => {
		dispatch(changeApplicationPolicySettings('openApplyPigModal', false));
	};

	const _applyPig = () => {
		dispatch(applyPig({ applicationId: newApplication.selectedApplication.id }));
	};

	const toggleCostsSummaryModal = () => {
		setCostsSummaryModalOpen(prev => !prev);
	};

	const toggleInternalAlertModal = () => {
		setInternalAlertModal(prev => !prev);
	};

	const _changeNewAppField = useCallback((field, value) => dispatch(changeNewAppField(field, value)), [dispatch]);
	const changeAppPolicySettings = useCallback((setting, value) => dispatch(changeApplicationPolicySettings(setting, value)), [dispatch]);
	const _changePremiumSettingsWizardStore = useCallback((key, value) => dispatch(changePremiumSettingsWizardStore(key, value)), [dispatch]);
	const handleCheck = useCallback(
		value =>
			PREMIUM_SETTINGS_CHECKBOX_OPTIONS.map(c => c.id).includes(value) === false
				? null
				: dispatch(changeApplicationPolicySettings('premiumSettingsType', value)),
		[dispatch],
	);
	const selectAppStatus = useCallback((machineName, displayName) => dispatch(selectApplicationStatus(machineName, displayName)), [dispatch]);
	const checkOverviewTabCheckBox = useCallback((checkBoxLabel) => dispatch(checkUserOverviewTabCheckBox(checkBoxLabel)), [dispatch]);
	const deleteDocument = useCallback((applicationId, attachmentId, relativeUrl) => dispatch(requestDeleteDocument(applicationId, attachmentId, relativeUrl)), [dispatch]);
	const pageShift = useCallback((direction, totalPaginationBoxes) => dispatch(overviewTabPageShift(direction, totalPaginationBoxes)), [dispatch]);
	const changeOverviewReadMoreState = useCallback((key, value) => dispatch(changeOverViewTabReadMoreState(key, value)), [dispatch]);
	const selectActiveTab = useCallback((tab) => dispatch(changeActiveTab(tab)), [dispatch]);
	const patchNotification = useCallback((notificationId, viewed, applicationId) => dispatch(requestPatchNotification(notificationId, viewed, applicationId)), [dispatch]);
	const fetchApplicationAttachment = useCallback((payload) => dispatch(requestApplicationAttachment(payload)), [dispatch]);
	const transferApplicationSettings = useCallback((setting, value) => dispatch(transferApplicationBetweenSolicitorUsers(setting, value)), [dispatch]);
	const updatePolicyField = useCallback((field, value) => dispatch(changeUpdatePolicyField(field, value)), [dispatch]);
	const previewFile = useCallback((attachment) => dispatch(openFilePreview(attachment)), [dispatch]);
	const renameAttachment = useCallback((applicationId, attachmentId, newName, relativeUrl) => dispatch(requestRenameAttachment(applicationId, attachmentId, newName, relativeUrl)), [dispatch]);
	const handleOpenRenameAttachmentModal = useCallback((attachment) => dispatch(openRenameAttachmentModal(attachment)), [dispatch]);
	const handleCloseRenameAttachmentModal = useCallback(() => dispatch(closeRenameAttachmentModal()), [dispatch]);
	const handleCloseFilePreview = useCallback(() => dispatch(closeFilePreview()), [dispatch]);
	const handleDownloadFilePreview = useCallback(() => { filePreview.file && _getFileFromBase64(filePreview.file); }, [filePreview.file]);

	const statusOptions = userDropDownStatusOptions(
		newApplication.selectedApplication.policyStatus,
		newApplication.selectedApplication.referredToName || newApplication.selectedApplication.roleGroupName,
		applicationAcceptedStatusesTransitions,
		newApplication.selectedApplication.policyStatusMachineName
	);

	const handleOpenStatusModal = () => changeAppPolicySettings('openModal', true);
	const handleCloseStatusModal = () => changeAppPolicySettings('openModal', false);
	const handleCloseTransferModal = () => transferApplicationSettings('openTransferApplicationModal', false);
	const handleClearStatus = () => {
		selectAppStatus('', '');
		_changeNewAppField(BAD_MSG, '');
		_changePremiumSettingsWizardStore('badResponseMsg', '');
	}

	const handleDismissCostsSummaryError = () => updatePolicyField('costsSummaryError', '');
	const handleStatusChange = (evt) => {
		const selected = statusOptions.find(o => o.key === evt.target.value);
		selectAppStatus(evt.target.value, selected?.label || selected?.value || evt.target.value);
	};
	const handleFieldChange = (e) => _changeNewAppField(e.target.name, e.target.value);
	const handleMarkAsViewed = () => patchNotification(applicationPolicy.notification?.id, true, newApplication.selectedApplication.id);
	const handleTransferCase = () => {
		handleSolicitorFirmSelect(newApplication.selectedApplication.lawsysId);
		handleSolicitorSelect(newApplication.selectedApplication.applicationUserId);
		transferApplicationSettings('openTransferApplicationModal', true);
	};

	const isChangeStatusModalOpen = applicationPolicy.openModal && (applicationPolicy.selectedStatusMachineName === '' || (applicationPolicy.selectedStatusMachineName === POLICY_STATUS_MN_REFERRED && (applicationPolicy.selectedReferredOptions === '')));

	return (
		<React.Fragment>
			<ApplicationPolicy
				badResponseAppPsMessage={badResponseAppPsMessage}
				isEditingApplicationPremium={isEditingApplicationPremium}
				editApplicationPremium={editApplicationPremium}
				cancelEditOfApplicationPremium={cancelEditOfApplicationPremium}
				match={match}
				_openAdvancedDisbursementsApplicationModal={_openAdvancedDisbursementsApplicationModal}
				_closeAdvancedDisbursementsApplicationModal={_closeAdvancedDisbursementsApplicationModal}
				router={router}
				handleCheck={handleCheck}
				CheckUserOverviewTabCheckBox={checkOverviewTabCheckBox}
				RequestDeleteDocument={deleteDocument}
				PageShift={pageShift}
				ChangeOverViewTabReadMoreState={changeOverviewReadMoreState}
				User={user}
				UpdateTab={updateTab}
				SavedApplicationAttachments={newApplication.hasOwnProperty('attachmentsForDisplay') ? newApplication.attachmentsForDisplay : []}
				SelectedApp={newApplication.selectedApplication}
				SelectActiveTab={selectActiveTab}
				Store={applicationPolicy}
				_updatePolicyStatus={_updatePolicyStatus}
				newApplication={newApplication}
				requestApplicationAttachment={fetchApplicationAttachment}
				handleSolicitorSelect={handleSolicitorSelect}
				handleSolicitorFirmSelect={handleSolicitorFirmSelect}
				SolicitorFirms={lawsysFirms}
				TransferApplicationBetweenSolicitorUsers={transferApplicationSettings}
				_transferApplication={_transferApplication}
				AgentsList={agentsList}
				costsSummaryModal={costsSummaryModalOpen}
				toggleCostsSummaryModal={toggleCostsSummaryModal}
				internalAlerts={internalAlerts}
				toggleInternalAlertModal={toggleInternalAlertModal}
				internalAlertsModalOpen={internalAlertModal}
				openFilePreview={previewFile}
				requestRenameAttachment={renameAttachment}
				openRenameAttachmentModal={handleOpenRenameAttachmentModal}
				closeRenameAttachmentModal={handleCloseRenameAttachmentModal}
				isArag={isArag}
				isSolicitor={isSolicitor}
				isChangeStatusModalOpen={isChangeStatusModalOpen}
				statusOptions={statusOptions}
				advanceDisbursementsEnabled={advanceDisbursementsEnabled}
				setEditingStaged={setEditingStaged}
				editingStaged={editingStaged}
				closePremiumSettingsModal={closePremiumSettingsModal}
				handleOpenStatusModal={handleOpenStatusModal}
				handleCloseStatusModal={handleCloseStatusModal}
				handleCloseTransferModal={handleCloseTransferModal}
				handleClearStatus={handleClearStatus}
				handleDismissCostsSummaryError={handleDismissCostsSummaryError}
				handleStatusChange={handleStatusChange}
				handleFieldChange={handleFieldChange}
				handleMarkAsViewed={handleMarkAsViewed}
				handleTransferCase={handleTransferCase}
				handleOpenApplyPigModal={handleOpenApplyPigModal}
				handleCloseApplyPigModal={handleCloseApplyPigModal}
				_applyPig={_applyPig}
			/>
			<FilePreviewModal
				isOpen={filePreview.isOpen}
				file={filePreview.file}
				loading={filePreview.loading}
				error={filePreview.error}
				onClose={handleCloseFilePreview}
				onDownload={handleDownloadFilePreview}
			/>
		</React.Fragment>
	);
};

export default ApplicationPolicyHOC;
